import {
    Description,
    Dialog,
    DialogHeader,
    DialogRoot,
    Heading,
    useOverlayTriggerState,
} from '@gitbook/spine-react';

import { SpaceCreationDialog } from '../../Space';
import { CreateSiteSectionForm, type CreateSiteSectionFormProps } from './CreateSiteSectionForm';

export interface CreateSiteSectionDialogProps
    extends Omit<CreateSiteSectionFormProps, 'spaces' | 'createSpaceDialogTrigger'> {}

export function CreateSiteSectionDialog(props: CreateSiteSectionDialogProps) {
    return (
        <Dialog>
            <SectionDialogContent {...props} />
        </Dialog>
    );
}

function SectionDialogContent(props: CreateSiteSectionDialogProps) {
    const createSpaceDialogTrigger = useOverlayTriggerState();

    return (
        <>
            <DialogRoot {...createSpaceDialogTrigger.rootProps}>
                <SpaceCreationDialog organizationId={props.organization.id} />
            </DialogRoot>
            <DialogHeader>
                <Heading>Name the section</Heading>
                <Description>One last step before adding the section.</Description>
            </DialogHeader>
            <CreateSiteSectionForm {...props} />
        </>
    );
}
